import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { instance } from "./httpConfig";

//getallbrands
export const useGetCurrencies = (page, limit, search) => {
  // console.log(storeId);
  return useQuery(
    ["currency", page, limit, search],
    async () => {
      const request = instance
        .get(`/currency?page=${page}&limit=${limit}&search=${search}`)
        .then((res) => res?.data)
        .catch((err) => {
          throw err;
        });
      return request;
    },
    {
      retry: 1,
      refetchOnWindowFocus: false,
      retryDelay: 3000,
    }
  );
};

export const useUpdateCurrency = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data) =>
      toast.promise(
        instance
          .patch("/currency", data)
          .then((res) => res.data)
          .catch((err) => {
            throw err;
          }),
        {
          success: "Currency updated",
          loading: "Please wait...",
          error: "Something happened",
        },
        {
          style: {
            minWidth: "180px",
          },
        }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["currency"]);
      },
    }
  );
};
